// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__eUYUi","imageUploader":"EGiftCard_imageUploader__15cI8"};